import { useSyncExternalStore } from 'react'
import { audioPlayer } from 'services/audio-player'

/** True while the given bot message's TTS queue is playing. */
export const useIsAudioPlaying = (messageId: string) =>
  useSyncExternalStore(audioPlayer.subscribe, () => audioPlayer.getPlayingMessageId() === messageId)

/** True between arming a message for playback (listen tap / voice send) and its first
 *  audible segment — i.e. "TTS is being synthesized". Derived from the player: no local
 *  state to keep in sync, ends on first playback, on stop, or on end-without-audio. */
export const useIsAudioLoading = (messageId: string) =>
  useSyncExternalStore(
    audioPlayer.subscribe,
    () => audioPlayer.getExpectedMessageId() === messageId && audioPlayer.getPlayingMessageId() !== messageId,
  )
